import React, { useEffect, useState} from "react";
import {Icon} from 'antd';
import _ from "i18n";


const ChoosePayinType = ({setPayinType, showBankwires}) => {

    return (
      <div className={"flex items-center justify-center"} style={{'padding' : '1.5rem', 'height' : '100%'}}>
        <div className={"payin-type-options-container"}>
          <div className={"payin-type-title"}>{_("CHOOSE_WALLET_FEEDING_MODE")}</div>

          <div className={'payin-type-option mb-8'} onClick={() => setPayinType("BANKWIRE")}>
            <Icon type="bank" theme="twoTone" style={{fontSize: "18px"}}/>
            <span className={"ml-3"}>{_('transferCardTitle')}</span>
          </div>

          <div className={'payin-type-option'} onClick={() => setPayinType("CARD")}>
            <Icon type="credit-card" theme="twoTone" style={{fontSize: "18px"}}/>
            <span className={"ml-3"}>{_('BANK_CARD')}</span>
          </div>

          <div className={'view-bankwires mt-10'}>
            <span onClick={() => showBankwires()}>{_("SEE_BANK_TRANSFERS")}</span>
          </div>

        </div>
      </div>
    );

}
export default ChoosePayinType;



// WEBPACK FOOTER //
// ./app/components/Admin/FeedMangoWallet/ChoosePayinType.js